export default (props) => {
  return props.render
}